import axios from 'axios';

const instance = axios.create();

// 响应拦截器：统一处理 401
// instance.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response && error.response.status === 401) {
//             const url = error.response.config.url;
//             // 排除登录、注册等无需认证的接口
//             const excludeUrls = ['/login', '/register', '/resetPwd'];
//             const shouldSkip = excludeUrls.some(ex => url.includes(ex));
//             if (shouldSkip) {
//                 return Promise.reject(error);
//             }
//             // 清除本地存储的 token
//             localStorage.removeItem('logintoken');
//             // 跳转到登录页（使用 location.href 避免路由守卫重复跳转）
//             window.location.href = '/login';
//             return Promise.reject(error);
//         }
//         return Promise.reject(error);
//     }
// );

// 登录请求方法
const loginreq = (method, url, params) => {
    return instance({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
        traditional: true
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    //get/delete传递参数和post/put不一样
    if (method === 'get' || method === 'delete') {
        return instance({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('logintoken')
            },
            params: params,
            traditional: true,
        }).then(res => res.data);
    } else {
        return instance({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('logintoken')
            },
            data: params,
            traditional: true,
        }).then(res => res.data);
    }

};

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js